import { Button, Form, Input, message, Select } from 'antd'
import { useState } from 'react'
import httpClient from '../../api/bioApi';
import { extractErrorMessage } from '../../utils/utils';
import { SUBMIT_LEADGEN_URL } from "../../api/URLs";

export default function PartnerRequestForm() {
    const [form] = Form.useForm();
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();

    async function handleSubmit(data) {
        setLoading(true);
        try {
            // Send POST request
            await httpClient.post(SUBMIT_LEADGEN_URL, data);

            // Success
            setSubmitted(true);
            messageApi.success('Request submitted successfully!');
        } catch (error) {
            messageApi.error(extractErrorMessage(error));
        } finally {
            setLoading(false);
        }
    }

    if (submitted) {
        return <div className="mt-6 bg-white p-6 rounded-lg shadow">
            <div className="font-semibold">Thank you — our team will reach out shortly.</div >
            <div className="mt-2 text-sm text-slate-600">You’re now part of the Balynced Tech Solutions interest list.</div>
        </div>
    }
    return (
        <>
            {contextHolder}
            <Form form={form} onFinish={handleSubmit} className='mt-6'>
                <Form.Item
                    name="fullName"
                    rules={[
                        { required: true, message: 'Full Name is required' },
                        { min: 3, message: 'Full Name must be at least 3 characters' },
                        { max: 100, message: 'Full Name cannot exceed 100 characters' }
                    ]}
                >
                    <Input name="name" placeholder="Full Name" className="px-4 py-3 rounded-lg border border-slate-200 no-antd-hover-focus" />
                </Form.Item>
                <Form.Item
                    name="email"
                    rules={[
                        { required: true, message: 'Email is required' },
                        { type: 'email', message: 'Please enter a valid email' }
                    ]}
                >
                    <Input name="email" placeholder="Business Email" className="px-4 py-3 rounded-lg border border-slate-200 no-antd-hover-focus" />
                </Form.Item>
                <Form.Item
                    name="practiceType"
                    rules={[
                        { required: true, message: 'Practice Type is required' },
                        { max: 50, message: 'Practice Type cannot exceed 50 characters' }
                    ]}
                >
                    <Select name="practiceType" placeholder="Practice Type" className="text-start rounded-lg border !border-slate-200 no-antd-hover-focus" style={{ height: "48px" }}>
                        <Select.Option value="Concierge / Direct Care">Concierge / Direct Care</Select.Option>
                        <Select.Option value="Integrative medicine">Integrative medicine</Select.Option>
                        <Select.Option value="Aesthetics / Longevity">Aesthetics / Longevity</Select.Option>
                    </Select>
                </Form.Item>
                <Form.Item>
                    <Button htmlType='submit' block style={{ height: "48px" }} className="rounded-lg bg-slate-900 text-white shadow disabled:opacity-60 no-antd-hover-focus" disabled={loading} loading={loading}>
                        <span className='font-medium'>
                            {loading ? 'Submitting...' : 'Request Access'}
                        </span>
                    </Button>
                </Form.Item>
            </Form>
        </>
    )
}
